import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveWithArrowKeyAction extends AbstractProvidedClass {
    constructor(provider, direction) {
        super(provider);
        this.elementCollection = this.selection.items;
        this.movement = this.getMovement(direction);
    }

    finish() {
        this.elementCollection.map(e => e.move(...this.movement));
        this.actions.finish();
    }

    undo() {
        this.elementCollection.map(e => e.move(...this.getOppositeMovement(this.movement)));
    }

    redo() {
        this.elementCollection.map(e => e.move(...this.movement));
    }

    getMovement(direction) {
        switch (direction) {
            case 'up':
                return [0, -this.getMovementSize()];
            case 'down':
                return [0, this.getMovementSize()];
            case 'left':
                return [-this.getMovementSize(), 0];
            case 'right':
                return [this.getMovementSize(), 0];
        }
    }

    getOppositeMovement(movement) {
        return movement.map(value => -value);
    }

    getMovementSize() {
        return this.grid.minorSize / this.view.scale;
    }
}
